import API from '../../../../../services/api';
import { headers } from '../helpers/functionalities';

export const ENTIDADES_API = {
    get: async (page = 1, search = null) => {
        return await API.get(`/entities?page=${page}${search || ''}`).then(res => res.data);
    },
    getById: async (id) => {
        return API.get(`/entities/${id}`).then(res => res.data);
    },
    getSheet: async (section, search = null, page, idCliente) => {
        return API.get(`/entities/${idCliente}?page=${page}&seccion=${section}${search ? `&${search}` : ''}`).then(res => res.data);
    },
    getInvoices: async (clienteId) => {
        return API.get(`/entities/${clienteId}/invoices`).then(res => res.data);
    },
    getDetail: async (clienteId) => {
        return API.get(`/entities/${clienteId}/detail`).then(res => res.data);
    },
    getAddressInfo: async (clienteId) => {
        return API.get(`/entities/${clienteId}/address-info`).then(res => res.data);
    },
    new: async (cliente) => {
        return API.post('/entities', cliente).then(res => res.data);
    },
    search: async (cliente) => {
        return API.post('/entities/buscar', cliente).then(res => res.data);
    },
    checkEntities: async (cliente) => {
        return API.post('/entities/comprobar', cliente).then(res => res.data);
    },
    checkEntity: async (clienteId) => {
        return API.post(`/entities/${clienteId}/comprobar`, {}).then(res => res.data);
    },
    downloadDoc: async (doc) => {
        return API.post('/entities/download', {documento: doc}, {responseType: 'blob'}).then(res => res.data);
    },
    exportFacturas: async (data) => {
        return API.post('/entities/export/extraccion', data, {responseType: 'blob'}).then(res => res.data);
    },
    exportCompras: async (data) => {
        return API.post('/entities/export/compras', data, {responseType: 'blob'}).then(res => res.data);
    },
    exportComprasMargen: async (data) => {
        return API.post('/entities/export/margen', data, {responseType: 'blob'}).then(res => res.data);
    },
    exportFeedback: async (data) => {
        return API.post('/entities/export/feedback', data, {responseType: 'blob'}).then(res => res.data);
    },
    join: async (data) => {
        return API.post('/entities/merge', data).then(res => res.data);
    },
    import: async (data) => {
        return API.post('/entities/import/excel', data, headers).then(res => res.data);
    },
    exportCreditInvoices: async (clienteId) => {
        return API.post(`/entities/${clienteId}/export-facturas-credito`, null, {responseType: 'blob'}).then(res => res.data);
    },
    update: async (cliente) => {
        return API.post('/entities/' + (cliente instanceof FormData ? cliente.get("id") : cliente.id) + '/update', cliente, (cliente instanceof FormData ? headers : null)).then(res => res.data);
    }
}

